import { Pipe, PipeTransform } from '@angular/core';
import { DimensionsUnitsEnum } from '../enums/dimensions-units.enum';
import convertDimensions from '../helpers/dimensions-weight';

@Pipe({
  name: 'convertDimensions',
})
export class ConvertDimensionsPipe implements PipeTransform {
  transform(
    value: number | string,
    fromUnit = DimensionsUnitsEnum.MM,
    toUnit = DimensionsUnitsEnum.CM,
  ): string | number {
    let result = value;
    if (value) {
      result = convertDimensions(value, fromUnit, toUnit).toFixed(2);
    }
    return result === 'NaN' || !result ? '-' : result;
  }
}
